/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_AddInputs */



/**
* | output |
* | --- |
* | "Add document" |
*
* @param {Meeting_Sources_Document_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_add = /** @type {((inputs?: Meeting_Sources_Document_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Document toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un document")
	return /** @type {LocalizedString} */ ("Add document")
});